// extracted by mini-css-extract-plugin
export default {"errorPageSubText":"app_errorPageSubText__wlaVZ","appNavigationButton":"app_appNavigationButton__W9BmB"};